/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_dac512cf',
  textField: 'textField_dac512cf',
  eventWithLabel: 'eventWithLabel_dac512cf',
  eventWithoutLabel: 'eventWithoutLabel_dac512cf',
};

export = styles;

loadStyles([{"rawString":".root_dac512cf{box-sizing:border-box;box-shadow:none;margin:0;padding:0;margin-bottom:17px}.textField_dac512cf{position:relative}.textField_dac512cf input::-ms-clear{display:none}.textField_dac512cf input[readonly]{cursor:pointer}.eventWithLabel_dac512cf{color:"},{"theme":"neutralSecondary","defaultValue":"#666666"},{"rawString":";font-size:20px;line-height:20px;pointer-events:none;position:absolute;bottom:5px}[dir=ltr] .eventWithLabel_dac512cf{right:9px}[dir=rtl] .eventWithLabel_dac512cf{left:9px}.eventWithoutLabel_dac512cf{color:"},{"theme":"neutralSecondary","defaultValue":"#666666"},{"rawString":";font-size:20px;line-height:20px;pointer-events:none;position:absolute;top:7px}[dir=ltr] .eventWithoutLabel_dac512cf{right:9px}[dir=rtl] .eventWithoutLabel_dac512cf{left:9px}"}]);
/* tslint:enable */